import { CATS, TRAT } from './services';

// Derived from CATS/TRAT rather than duplicated, same as the prototype --
// keeps the /precios menu and the per-treatment detail pages from drifting
// apart. The three extra line items (retiro de acrílico/gel, nail art,
// retiro de extensiones) only exist here, not as full treatment pages.
export const MENU = CATS.map((c) => ({
  nombre: c.nombre,
  items: (TRAT[c.id] ?? []).map((t) => ({
    nombre: t.nombre,
    nota: t.etiqueta,
    duracion: t.duracion,
    precio: t.precio,
  })),
}));

const unasGroup = MENU.find((g) => g.nombre === 'Uñas');
if (unasGroup) {
  unasGroup.items.push(
    { nombre: 'Retiro de acrílico o gel', nota: 'Con limado controlado', duracion: '30 min', precio: '$150' },
    { nombre: 'Nail art por uña', nota: 'Según complejidad del diseño', duracion: '—', precio: 'desde $50' }
  );
}

const pestanasGroup = MENU.find((g) => g.nombre === 'Pestañas');
if (pestanasGroup) {
  pestanasGroup.items.push({
    nombre: 'Retiro de extensiones',
    nota: 'Con removedor profesional',
    duracion: '30 min',
    precio: '$150',
  });
}
